// @ts-strict-ignore
import { Reducer } from '@reduxjs/toolkit';
import { createTrivialCustomGrouping } from '../../model/custom-grouping/customGrouping';
import { CustomGroupingAction, CustomGroupingActionType } from './actions';
import { createDefaultState, CustomGroupingDrawerStatus, CustomGroupingState } from './state';

const reducer: Reducer<CustomGroupingState, CustomGroupingAction> = (
  state = createDefaultState(),
  action,
) => {
  switch (action.type) {
    case CustomGroupingActionType.OPEN_CREATE_DRAWER: {
      return {
        saveModalOpen: false,
        drawerStatus: CustomGroupingDrawerStatus.CREATE,
        syntaxGuideOpen: false,
        grouping: createTrivialCustomGrouping(),
        direction: null,
      };
    }

    case CustomGroupingActionType.OPEN_EDIT_DRAWER: {
      return {
        saveModalOpen: false,
        drawerStatus: CustomGroupingDrawerStatus.EDIT,
        syntaxGuideOpen: false,
        grouping: action.payload.grouping,
        direction: action.payload.direction,
      };
    }

    case CustomGroupingActionType.OPEN_VIEW_DRAWER: {
      return {
        saveModalOpen: false,
        drawerStatus: CustomGroupingDrawerStatus.VIEW,
        syntaxGuideOpen: false,
        grouping: action.payload,
        direction: null,
      };
    }

    case CustomGroupingActionType.CLOSE_DRAWER: {
      return createDefaultState();
    }

    case CustomGroupingActionType.SET_GROUPING_TREE: {
      return {
        ...state,
        grouping: {
          ...state.grouping,
          rootNode: action.payload,
        },
      };
    }

    case CustomGroupingActionType.SET_SAVE_MODAL_OPEN: {
      return {
        ...state,
        saveModalOpen: action.payload,
      };
    }

    case CustomGroupingActionType.SET_GROUPING_FOR_SAVE: {
      return {
        ...state,
        saveModalOpen: true,
        grouping: action.payload,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default reducer;
